(() => {
 const init = (scope = document) => scope.querySelectorAll('[data-bbcr-home]').forEach(root => {
  if(root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const video = root.querySelector('video'), button = root.querySelector('[data-bbcr-video-toggle]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const update = () => {button.textContent = video.paused ? root.dataset.play : root.dataset.pause; button.setAttribute('aria-label', button.textContent);button.setAttribute('aria-pressed',String(!video.paused));};
  button.addEventListener('click', () => {if(video.paused) video.play().catch(update); else video.pause();});
  video.addEventListener('play', update);video.addEventListener('pause', update);
  if(!reduced.matches) video.play().catch(update);
  reduced.addEventListener('change', () => {if(reduced.matches) video.pause();});update();
 });
 init();document.addEventListener('shopify:section:load', e => init(e.target));
})();